export class Categories {
  private static instance: Categories
  public static getInstance(): Categories {
    if (!Categories.instance) {
      Categories.instance = new Categories()
    }
    return Categories.instance
  }

  // Pokud bude více výchozích kategorií, probrat jak zobrazit textaci v OrdersList.vue
  private static defaultCategories = {
    categories: {
      key: 'categories',
      value: 'basic',
      icon: 'fa-box',
      showInGridFilter: true,
    },
  }

  // reaktivní, aby computed konzumenti (menu, pod-nav, filtry, produktový form) reagovali na
  // doplnění/odebrání dynamických kategorií.
  private static categories: { [type: CategoryWithoutLabels['key']]: CategoryWithoutLabels } =
    reactive({
      ...this.defaultCategories,
    })

  public static labels() {
    const nuxtApp = useNuxtApp()

    return computed<{ [key: string]: { title: Category['title']; label: Category['label'] } }>(
      () => ({
        categories: {
          title: nuxtApp.$i18n?.t('Kategorie'),
          label: {
            1: nuxtApp.$i18n?.t('Obecné'),
            2: nuxtApp.$i18n?.t('Obecných'),
          },
        },
      })
    )
  }

  // store je reactive() → případný Component v `input` musí být markRaw, jinak ho Vue
  // zabalí do proxy ("received a Component that was made reactive") a rozbije custom input
  private static rawInputs(cats: { [key: Category['key']]: Category }) {
    for (const category of Object.values(cats)) {
      if (category.input) {
        category.input = markRaw(category.input)
      }
    }
    return cats
  }

  public extendCategories(newCategories: { [key: Category['key']]: Category }) {
    // mutace (ne reassign), aby zůstala zachovaná reaktivita
    Object.assign(Categories.categories, Categories.rawInputs(newCategories))
  }

  public setDynamicCategories(dynamic: { [key: Category['key']]: Category }) {
    for (const key of Object.keys(Categories.categories)) {
      if (!(key in Categories.defaultCategories)) {
        delete Categories.categories[key]
      }
    }
    Object.assign(Categories.categories, Categories.rawInputs(dynamic))
  }

  public getCategories(): { [type: Category['key']]: Category } {
    const labels = Categories.labels().value
    return Object.fromEntries(
      Object.entries(Categories.categories).map(([key, category]) => [
        key,
        { ...category, ...labels[key]! },
      ])
    )
  }

  public getDefaultCategories(): { [type: Category['key']]: Category } {
    const labels = Categories.labels().value
    return Object.fromEntries(
      Object.entries(Categories.defaultCategories).map(([key, category]) => [
        key,
        { ...category, ...labels[key]! },
      ])
    )
  }

  public getCategoryByKey(key: string) {
    return Categories.categories[key]
  }

  public getPreviewActions(): string[] {
    return Object.values(Categories.categories)
      .map((category) => category.previewAction)
      .filter((action): action is string => !!action)
  }
}
export type Category = {
  key: string
  icon: string
  value: string
  label: {
    1: string
    2: string
  }
  title: string
  help?: string
  showInGridFilter: boolean
  showInProductsFilter?: boolean
  input?: Component
  previewAction?: string
  gridKey?: string
}
export type CategoryWithoutLabels = Omit<Category, 'label' | 'title'>
